/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { MorfianateImageResponse, MorfianateImageVars } from '../openapi-types.gen.js';

export type { MorfianateImageResponse, MorfianateImageVars } from '../openapi-types.gen.js';

export const useMorfianateImage = createMutationHook<MorfianateImageVars, MorfianateImageResponse, unknown>({
  specName: 'useMorfianateImage',
  path: '/v1/images/morfianate',
  method: 'POST',
  resolveUrl: (vars: MorfianateImageVars) => `/v1/images/morfianate`,
  buildBody: (vars: MorfianateImageVars) => {
    const fd = new FormData();
    if (vars.image !== undefined) fd.append('image', vars.image);
    if (vars.description !== undefined) fd.append('description', String(vars.description));
    return fd;
  },
  parseResponse: (raw: unknown): MorfianateImageResponse => raw as MorfianateImageResponse,
  optimistic: [{
    queryKey: ['images', 'detail'],
    apply: (prev: any, vars: MorfianateImageVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = { ...next, used: String((Number((next as any).used) || 0) + Number(("1" /* literal */))) };
      next = { ...next, remaining: String((Number((next as any).remaining) || 0) + Number(("-1" /* literal */))) };
      return next;
    },
  }],
  
  
});
